export default "__VITE_ASSET__CHyf0mNB__"